import { render, staticRenderFns } from "./a1.vue?vue&type=template&id=9c87bffe&scoped=true&"
import script from "./a1.vue?vue&type=script&lang=js&"
export * from "./a1.vue?vue&type=script&lang=js&"
import style0 from "./a1.vue?vue&type=style&index=0&id=9c87bffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c87bffe",
  null
  
)

export default component.exports